export default {
  state: {
    error: {},
    raised: false
  },
  mutations: {
    raise(state, error){
      state.error = error
      state.raised = true
    },
    raised(state, value){
      state.raised = value
    }
  },
  actions: {
    raise({commit}, error){
      commit('raise', error)
    }
  },
  getters: {
    raised(state){
      return state.raised
    },
    error(state){
      return state.error
    }
  }
}